declare namespace $ {

	type $mol_float__dom_name_shm_hitalama_benchmarks_page_metrics_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_float['dom_name'] >
	>
	type $mol_float__sub_shm_hitalama_benchmarks_page_metrics_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page_metrics['col_head_content'] >
		,
		ReturnType< $mol_float['sub'] >
	>
	type $mol_float__attr_shm_hitalama_benchmarks_page_metrics_3 = $mol_type_enforce<
		({ 
			'indexed': ReturnType< $shm_hitalama_benchmarks_page_metrics['indexed_column'] >,
		})  & ReturnType< $mol_float['attr'] >
		,
		ReturnType< $mol_float['attr'] >
	>
	type $shm_hitalama_benchmarks_page_metrics_details__computer_shm_hitalama_benchmarks_page_metrics_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page_metrics['details_computer'] >
		,
		ReturnType< $shm_hitalama_benchmarks_page_metrics_details['computer'] >
	>
	type $shm_hitalama_benchmarks_page_metrics_details__browser_shm_hitalama_benchmarks_page_metrics_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page_metrics['details_browser'] >
		,
		ReturnType< $shm_hitalama_benchmarks_page_metrics_details['browser'] >
	>
	type $shm_hitalama_benchmarks_page_metrics_delete__remove_shm_hitalama_benchmarks_page_metrics_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page_metrics['row_delete'] >
		,
		ReturnType< $shm_hitalama_benchmarks_page_metrics_delete['remove'] >
	>
	type $shm_hitalama_benchmarks_page_metrics_delete__enabled_shm_hitalama_benchmarks_page_metrics_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page_metrics['delete_enabled'] >
		,
		ReturnType< $shm_hitalama_benchmarks_page_metrics_delete['enabled'] >
	>
	export class $shm_hitalama_benchmarks_page_metrics extends $mol_grid {
		col_head_content( id: any): readonly($mol_view_content)[]
		indexed_column( id: any): boolean
		details_computer( id: any): string
		details_browser( id: any): string
		row_delete( id: any, next?: any ): any
		delete_enabled( id: any): boolean
		Col_head( id: any): $mol_float
		Details( id: any): $shm_hitalama_benchmarks_page_metrics_details
		Delete( id: any): $shm_hitalama_benchmarks_page_metrics_delete
	}
	
}

//# sourceMappingURL=metrics.view.tree.d.ts.map